
export const dept = {
    
    methods: {
        //获取部门及员工
        async getDeptaEmployeell() {
            let res = await this.$http.get('/tenant/user/all/user/by/dept')
            return res;
        },
        //查询全部部门（树形）
        async getDeptall() {
            let res = await this.$http.get('/tenant/dept/tree/list')
            return res.data;
        },
        //查询全部部门
        async getemDeptall() {
            let res = await this.$http.get('/tenant/dept/list')
            return res.data;
        },
        //TODO:查询全部部门(带第一级)
        async getemDeptall2() {
            let res = await this.$http.get('/tenant/dept/list2')
            return res.data;
        },
        //TODO:查询全部部门（带分页）
        async getemDeptallPages(params) {
            let {pageNum,pageSize,deptName} = params
            let res = await this.$http.get('/tenant/dept/list',{
              deptName:deptName??null,
              pageNum:pageNum??null,
              pageSize:pageSize??null
            });
            return res.data;
        },
        //TODO：查询全部部门（树形）带员工
        async getemDeptchildren() {
        let res = await this.$http.get('/tenant/dept/tree/with/employee/list')
        return res;
    },
        
        //查询指定部门
        async getDeptName(deptname, deptid) {
            let arr = []; 
            if (deptid) {//deptid
                let res = await this.$http.get('/dept/getDeptidState', {
                    deptid: deptid,
                })
                arr = res.data
            } else {//deptname
                let res = await this.$http.get('/dept/getDeptNameState', {
                    deptname: deptname,
                })
                arr = res.data
            }
            return arr
        },

        //查询根据deptid班组
        async getTeamall(deptid){
            let res = await this.$http.get('/tenant/dept/list', {
                parentId: deptid
            })
            if(!res.data) return []
            // for(let i =0;i<res.data.length;i++){
            //     res.data[i].label = res.data[i].teamname
            // }
            return res.data || []; 
        },
        //新增部门
        async addDept(obj) {
            let res = await this.$http.post('/tenant/dept', obj)
            if (res.code == 200) {
                this.$message({ message: res.msg, type: 'success' });
            } else {
                this.$message.error(res.msg);
            }
        },
        //修改部门
        async upDeptName(obj) {
            let res = await this.$http.put('/tenant/dept', obj);
            if (res.code == 200) {
                this.$message({message: res.msg, type: 'success' });
            } else {
                this.$message.error(res.msg);
                return
            }

        },
        //删除部门
        async deDeptName(obj) {
            let res = await this.$http.delete(`/tenant/dept/${obj.id}`);
            if (res.code == 200) {
                this.$message({message: res.msg, type: 'success' });
            } else {
                this.$message.error(res.msg);
                return
            }

        },
        //获取岗位
        async getpost(obj) {
            let res = await this.$http.get('/tenant/dictionary/content/list', {
                dictionaryName: '岗位'
            });
            return res.rows || []
        },
        //获取职务
        async getobj(obj) {
            let res = await this.$http.get('/tenant/dictionary/content/list', {
                dictionary_name: '职务'
            });
            return res.rows || []
        },
        //验证账号是否存在
        async existUsername(val){
            let res = await this.$http.get('/employee/getexistEmployeeid', {
                employeeid:val
            });
            return res || []
        },
        //新增员工
        async addUserInfo(obj, imgurl) {
            
            // 新增员工
            var res = await this.$http.post('/tenant/user', obj)
            
            //新增头像
            if (imgurl && res.code == 200 ) {//等待插入用户后，再上传头像，并把url插入到员工表里。
                let employeeId  = res.data
                let file = await this.$format.dataURLtoFile(imgurl, new Date().getTime() + '.png');
                let formData = new FormData();
                // formData.append('employeeId', employeeId);
                formData.append('file', file, new Date().getTime() + '.jpg');
                let respon = await this.$http.post(`/tenant/file/employee/photo/${employeeId}`, formData, {
                    "Content-Type": 'multipart/form-data'
                })
                if(respon.code == 200)  this.$message({ message: respon.msg, type: 'success' });
                else  this.$message({ message: respon.msg, type:'error' })
            }
            if (res.code == 200) {
                this.$message({ message: res.msg, type: 'success' });
                this.$router.go(-1)// 返回
                this.$store.commit("delete_tabs", this.$route.path);
            } else {
                this.$message.error(res.msg);
            }

        },
        //修改员工
        async upUserInfo(obj, imgurl) {
            //修改员工
            let ret = await this.$http.put('/tenant/user', obj)

            //如果用户没填密码
            if (!obj.password) {
                // let ret_02 = await this.$http.put('/employee/upEmployeePassword', obj)
                delete obj.password;
            }
        
            //如果用户选择了头像，进行修改
            if (imgurl && ret.code == 200) {

                let id = obj.id
                let file = await this.$format.dataURLtoFile(imgurl, new Date().getTime() + '.png');
                let formData = new FormData();
                formData.append('file', file, new Date().getTime() + '.jpg');
                let res = await this.$http.post(`/tenant/file/employee/photo/${id}`, formData, {
                    "Content-Type": 'multipart/form-data'
                })
                if(res.code == 200) this.$message({ message: res.msg, type: 'success' });
            }
            if (ret.code == 200) {
                //如果修改的是当前管理员时，重新存储到本地
                if(obj.id == this.userInfo.id){              
                    // TODO：再次查询当前用户，存到本地
                    let User = await this.$http.get(`/tenant/user/${obj.id }`)
                    let newUser = JSON.parse(JSON.stringify(User.data))
                    // let Role = await this.getemRole(obj.employeeid);
                    // newUser.roleName = Role[0]?.rolename;//权限
                    localStorage.setItem("user", JSON.stringify(newUser));
                    this.$store.commit("uploginUser", newUser);
                    this.userInfo = newUser;//重新存到全局
                }
                this.$message({ message: ret.msg, type: 'success' });
                this.$router.go(-1)// 返回
                this.$store.commit("delete_tabs", this.$route.path);
            } else {
                this.$message.error(ret.msg);
            }

        },
        
        //删除员工
        async deUserInfo(obj) {
            let  res = await this.$http.delete(`/tenant/user/${obj.id}`);
            if (res.code == 200) {
                this.$message({ message: res.msg, type: 'success' });
            } else {
                this.$message.error( res.msg);
                return
            }
        },


        //修改电子签名
        async upSignature(obj) {
             //修改员工
             let ret = await this.$http.put('/tenant/user', obj)

             //如果用户没填密码
             if (!obj.password) {
                 // let ret_02 = await this.$http.put('/employee/upEmployeePassword', obj)
                 delete obj.password;
             }
            
             if (ret.code == 200) {
                 //如果修改的是当前管理员时，重新存储到本地
                 if(obj.id == this.userInfo.id){              
                     // TODO：再次查询当前用户，存到本地
                     let User = await this.$http.get(`/tenant/user/${obj.id }`)
                     let newUser = JSON.parse(JSON.stringify(User.data))
                     // let Role = await this.getemRole(obj.employeeid);
                     // newUser.roleName = Role[0]?.rolename;//权限
                     localStorage.setItem("user", JSON.stringify(newUser));
                     this.$store.commit("uploginUser", newUser);
                     this.userInfo = newUser;//重新存到全局
                 }
                 this.$message({ message: ret.msg, type: 'success' });
               
             } else {
                 this.$message.error(ret.msg);
             }
        },
    },
}